import React from 'react'
import Linkify from 'react-linkify';

export default class extends React.Component
{
  render() {
    var message = this.props.message;
    // allowSkip: "false"
    // anim: "line"
    // autoDismiss: "false"
    // id: "14"
    // itemColor: "#666666"
    // position: "bottom"
    // style: "narrative"
    // type: "fullScreen"
    // urlColor: "#000000"
    // urlEnabled: "false"


    var text = this.props.text;

    // anim: "typewriter"
    // color: "#FFFFFF"
    // size: "xlarge"
    // style: "regular"

    if (!text || !text._text)
    {
      return null;
    }

    var anim = text._attributes.anim;
    var color = text._attributes.color;
    if (color && color.indexOf("#") < 0) {
      color = '#' + color;
    }
    var size = text._attributes.size;
    var style = text._attributes.style;

    var fontSize = '14pt';

    if (size === 'xlarge')
    {
      fontSize = '24pt'
    }
    else if (size === 'large')
    {
      fontSize = '18pt'
    }
    else if (size === 'small')
    {
      fontSize = '12pt'
    }

    var fontWeight = 'normal';
    if (style === 'light')
    {
      fontWeight = 'lighter';
    }
    else if (style === 'regular')
    {
      fontWeight = 'normal';
    }
    else
    {
      fontWeight = 'bold';
    }

    var width = 'auto';
    if (message._attributes.style==='chat'){
      width ='100%'
    }

    var bclassName = this.props.bubble_color && `speech-bubble-${this.props.bubble_color.replace("#", '')}`;
    if (global.DEBUG)
      console.log(text);
    var default_text_style = {
      position: `relative`, display: `inline-block`,
    }
    var default_innertext_style = {

    }
    if (this.props.is_header)
    {
      default_text_style = {

      };
      default_innertext_style = {
        textAlign: this.props.bPosition,
      };
    }
    return (
        <div id={'TBCText'} className={`${bclassName} ${bclassName}-${this.props.bPosition}`} {...this.props} style={Object.assign({}, default_text_style, {
          color: color, fontSize: fontSize, fontWeight: fontWeight,width:width,maxWidth:"100%",whiteSpace:"pre-wrap",wordWrap:"break-word"}, this.props.text_style, this.props.bubble_color ? {backgroundColor: this.props.bubble_color} : {})}>
          <div style={Object.assign({}, {}, default_innertext_style)}>
            {text && text._text && text._text.split("\n").map((txt, k) => {
              return (
                  <div key={k}>
                    <Linkify>
                      {(this.props.url)?(<a href={this.props.url} style={{color:color,textDecoration:`underline`}}>{txt}</a>)
                      
                      :txt
                      }
                      
                    </Linkify>
                  </div>
              )
            })}
          </div>



          {
            this.props.bubble_color ? (

                <style dangerouslySetInnerHTML={{__html: `
.${bclassName} {
	position: relative;
	background: ${this.props.bubble_color};
	border-radius: 14px;
	padding: 8px;
	margin-top: 20px;
}

.${bclassName}-right:after {
  content: '';
  position: absolute;
  top: 0;
  right: 10px;
  width: 0;
  height: 0;
  border: 9px solid transparent;
  border-bottom-color: ${this.props.bubble_color};
  border-top: 0;
  border-right: 0;
  margin-right: -4.5x;
  margin-top: -9px;
}

.${bclassName}-left:after {
	content: '';
	position: absolute;
	top: 0;
	left: 10px;
	width: 0;
	height: 0;
	border: 9px solid transparent;
	border-bottom-color: ${this.props.bubble_color};
	border-top: 0;
	border-left: 0;
	margin-left: -4.5x;
	margin-top: -9px;
}`}}>
                </style>
            ) : null
          }
        </div>
    );
  }

}